(() => {
  'use strict';

  const documentElement = document.documentElement;
  const readyAttribute = 'data-kjhs-funnel-ready';

  if (documentElement.hasAttribute(readyAttribute)) return;
  documentElement.setAttribute(readyAttribute, 'true');

  const eventName = 'kjhs:funnel';
  const rootSelector = '[data-kjhs-funnel]';
  let resultIsVisible = false;

  const getRoot = () => document.querySelector(rootSelector);

  const getResponseReference = () => {
    const hash = window.location.hash.replace(/^#/, '');
    return hash.indexOf('response-') === 0 ? hash.slice(0, 100) : '';
  };

  const getProductHandle = (href) => {
    try {
      const parts = new URL(href, window.location.origin).pathname.split('/').filter(Boolean);
      const productIndex = parts.indexOf('products');
      return productIndex > -1 && parts[productIndex + 1] ? parts[productIndex + 1] : '';
    } catch (error) {
      return '';
    }
  };

  const storageHas = (key) => {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  };

  const storageSet = (key) => {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      // Tracking remains functional when storage is unavailable.
    }
  };

  const emit = (name, details, deduplicationKey) => {
    const storageKey = deduplicationKey ? 'kjhs-funnel:' + deduplicationKey : '';
    if (storageKey && storageHas(storageKey)) return;

    const payload = Object.assign(
      {
        funnel: 'find_your_fibre',
        language: documentElement.lang || '',
        page_path: window.location.pathname
      },
      details || {}
    );

    if (storageKey) storageSet(storageKey);

    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: { event: name, kjhs_funnel: payload }
      })
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, kjhs_funnel: payload });
    }
  };

  const findLinkInEvent = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    return path.find((node) => node && node.tagName === 'A' && node.href) || null;
  };

  const handleClick = (event) => {
    const startLink = event.target.closest && event.target.closest('[data-kjhs-quiz-start]');
    if (startLink) {
      emit(
        'quiz_start',
        { placement: startLink.getAttribute('data-kjhs-quiz-start') || 'landing' },
        'quiz-start'
      );
      return;
    }

    const root = getRoot();
    if (!root || root.getAttribute('data-kjhs-funnel') !== 'quiz') return;

    const link = findLinkInEvent(event);
    const productHandle = link ? getProductHandle(link.href) : '';
    if (!link || !productHandle) return;

    link.setAttribute('data-kjhs-result-product', productHandle);
    emit('quiz_product_click', {
      product_handle: productHandle,
      response_reference: getResponseReference()
    });
  };

  const registerQuizRenderers = () => {
    document.querySelectorAll('quiz-renderer[data-quiz-instance-id]').forEach((renderer) => {
      renderer.setAttribute('data-kjhs-funnel-quiz', 'revenue-hunt');
    });
  };

  const isKnownQuizMessage = (data) => {
    if (
      !data ||
      data.channel !== 'revenuehunt:quiz-renderer' ||
      data.source !== 'quiz-renderer' ||
      !data.instanceId
    ) {
      return false;
    }

    return Array.from(document.querySelectorAll('quiz-renderer[data-quiz-instance-id]')).some(
      (renderer) => renderer.getAttribute('data-quiz-instance-id') === data.instanceId
    );
  };

  const handleQuizMessage = (event) => {
    const data = event.data;
    if (!isKnownQuizMessage(data)) return;

    if (data.type === 'nextQuestion') {
      emit('quiz_start', { placement: 'quiz' }, 'quiz-start');
      return;
    }

    if (data.type === 'isQuestion') {
      resultIsVisible = false;
      return;
    }

    if (data.type !== 'isResult' || resultIsVisible) return;

    resultIsVisible = true;
    const resultDetails = {
      provider: 'revenue_hunt',
      response_reference: getResponseReference()
    };
    emit('quiz_complete', resultDetails);
    emit('quiz_result', resultDetails);
  };

  const init = () => {
    const root = getRoot();
    if (!root) return;

    if (root.getAttribute('data-kjhs-funnel') === 'landing') {
      emit('find_fibre_view', {}, 'find-fibre-view:' + window.location.pathname);
    }

    registerQuizRenderers();
    document.addEventListener('click', handleClick, true);
    window.addEventListener('message', handleQuizMessage);

    if (root.getAttribute('data-kjhs-funnel') === 'quiz') {
      const observer = new MutationObserver(registerQuizRenderers);
      observer.observe(root.parentElement || root, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
